import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Tutorial Routes and Pages
 */
const ListTutorialPage = React.lazy(() => import("./ListTutorialPage"));
const AddTutorialPage = React.lazy(() => import("./AddTutorialPage.js"));
const EditTutorialPage = React.lazy(() => import("./EditTutorialPage"));

const TutorialRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTutorialPage />} />
      <Route exact path="/add" element={<AddTutorialPage />} />
      <Route exact path="/edit/:id" element={<EditTutorialPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default TutorialRoutes;
